//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import DOMPurify from 'dompurify';

export default {
  props: ['task'],
  computed: {
    isDone() {
      return (
        !!this.task.doneAtTimestampMs ||
        (this.task.type === "event" && this.task.event.status === "cancelled")
      );
    },
    name() {
      return this.task.name
    },
    markup() {
      // Make sure all links will open in new tab (by default DOMPurify
      // would remove target='_blank' attribute).
      DOMPurify.addHook('afterSanitizeAttributes', function (node) {
        if (node.hasAttribute('href')) {
          node.setAttribute('target', '_blank');
          node.setAttribute('rel', 'noopener');
        }
      });
      // If task.html is undefined, the result is ''.
      return DOMPurify.sanitize(this.task.html);
    },
    obscuredName() {
      return this.task.name.replace(/\p{L}/gu, '●').replace(/\p{N}/gu, '●');
    },
  },
  methods: {
    updateContent() {
      if (this.markup) {
        this.$refs.content.innerHTML = this.markup
      } else {
        this.$refs.content.textContent = this.task.name.trim()
      }
    },
  },
  mounted() {
    if (this.$root.markdownEnabled) {
      this.updateContent()
    }
  },
  watch: {
    name() {
      if (this.$root.markdownEnabled) {
        this.updateContent()
      }
    }
  }
};
